import { render, staticRenderFns } from "./KpiProviders.vue?vue&type=template&id=804587bc&scoped=true&"
import script from "./KpiProviders.vue?vue&type=script&lang=js&"
export * from "./KpiProviders.vue?vue&type=script&lang=js&"
import style0 from "./KpiProviders.vue?vue&type=style&index=0&id=804587bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804587bc",
  null
  
)

export default component.exports